import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import modules from './modules';
import plugins from './plugins';

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules,
  plugins,
});

setInterval(() => {
  store.state.now = new Date();
}, 1000);

export default store;
